import React from 'react';
import Container from 'react-bootstrap/Container';

function NotFound() {
  return (
    <Container className="text-center mb-5">
      <h1 className="mt-5">Evento não encontrado</h1>
    </Container>
  );
}

export default NotFound;
